const isSchema = obj => obj && obj.__isYupSchema__;

export default isSchema;


//////////////////
// WEBPACK FOOTER
// ./~/yup/es/util/isSchema.js
// module id = 62
// module chunks = 14